import { InfoIcon } from 'foundations-assets';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ReplyRecommendationCitationPopoverContent } from './ReplyRecommendationCitationPopoverContent';
import { trackEvent } from '../../../../usage-tracking/clients/usageTracker';
import { getViewCitationList } from '../../events/ReplyRecommendationCitationEvents';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReplyRecommendationCitationsButton = ({
  citationsList
}) => {
  const [popoverState, setPopoverState] = useState(false);
  const handleOpenChange = ({
    target: {
      value
    }
  }) => {
    setPopoverState(value);
  };
  return /*#__PURE__*/_jsx(Popover, {
    open: popoverState,
    onOpenChange: handleOpenChange,
    showCloseButton: true,
    content: /*#__PURE__*/_jsx(ReplyRecommendationCitationPopoverContent, {
      citationsList: citationsList
    }),
    children: /*#__PURE__*/_jsxs(Button, {
      margin: "0",
      size: "extra-small",
      use: "tertiary-light",
      "aria-pressed": popoverState,
      onClick: () => {
        setPopoverState(!popoverState);
        trackEvent(getViewCitationList());
      },
      children: [/*#__PURE__*/_jsx(InfoIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.reply-recommendations.citations.button"
      })]
    })
  });
};
ReplyRecommendationCitationsButton.displayName = 'ReplyRecommendationCitationsButton';